export default __webpack_public_path__ + "static/media/stablepay.d20bb9be.jpg";